export const replaceClubWikifolioTextVariables = (text: string, wikifolio?: string, club?: string) =>
    text.replace("{{WIKIFOLIO}}", wikifolio ?? "").replace("{{CLUB}}", club ?? "");
